export function isLocalStorageEnabled(): boolean {
  try {
    const key = '__sdk_payments_storage__test'
    window.localStorage.setItem(key, 'test_value')
    window.localStorage.removeItem(key)
    return true
  } catch (e) {
    return false
  }
}

export const isBrowser = () => {
  return typeof window !== 'undefined' && typeof window.document !== 'undefined'
}
